<div class="flex-container gap-16" style="height: 100%">
  <vl-widget-title [text]="'dashboard_ui.status_ofs' | trans" [widget]="widget()" [draggable]="true">
    <ng-content class="drag-handler" select='.drag-handler'></ng-content>
  </vl-widget-title>

  @if (metadata().loading) {
    <div class="h100 overflow-hidden">
      <ngx-skeleton-loader count="20" [theme]="{'background-color': 'var(--color-on-disabled)'}"/>
    </div>
  } @else {
    <div class="flex-col gap-4 overflow-scroll fade-in pl-md-32 gap-4">
      @for (item of arrayDatas(); track item.key) {
        <div class="flex-row align-center gap-8">
          <vl-icon-of-etat [etat]="item.key"></vl-icon-of-etat>
          <span class="body-2 on-background-alt grow">{{item.label}}</span>
          <span class="body-2 on-background">{{item.value}}</span>
        </div>
      } @empty {
        <span class="caption on-disabled">{{ 'list.empty' | trans }}</span>
      }
    </div>
  }
</div>
